export const newSale = {
  id: -1,
  idPaciente: -1,
  codPaciente: "",
  name: "",
  lastName: "",
  address: "",
  city: "",
  province: "",
  postalCode: "",
  nif: "",
  nifType: "00",
  factCodPaciente: "",
  factName: "",
  factNif: "",
  factNifType: "00",
  factAddress: "",
  factCity: "",
  factProvince: "",
  factPostalCode: "",
  factType: "",
  tipoFactura: "",
  serieFactura: "",
  numeroFacturaRectificada: "",
  nOperation: "",
  nFact: "",
  date: "",
  phone: "",
  status: "Venta",
  points: 0,
  cashVouncher: 0,
  soldBy: -1,
  deliveredBy: -1,
  campaign: -1,
  lines: [
    {
      id: -1,
      code: "",
      description: "",
      pvpOr: 0,
      pvp: 0,
      dto: 0,
      ivaOr: 0,
      iva: 0,
      pvu: 0,
      uds: 1,
      total: 0,
      stock: "",
      dtoMax: "",
      pvpOffer: "",
      offerFrom: "",
      offerTo: "",
      pvpSpecial: "",
      specialUds: 2,
      checkStock: false,
      healthControl: null,
      provider: "",
      providerId: "",
      commision: "",
      ivaBought: 0,
      cardId: -1,
      cardType: "",
      lastPurchaseBruto: "",
      lastPurchaseNeto: "",
    },
  ],
  paid: false,
  delivered: false,
  totalDto: 0,
  totalBase: 0,
  totalIVA: 0,
  total: 0,
  totalPaid: 0,
  totalRemaining: 0,
  payments: [],
  ivas: [
    {
      percIVA: 21,
      base: 0,
      iva: 0,
      total: 0,
    },
  ],
  carts: [],
  card: null,
  crossSelling: null,
  orderNumber: "",
  quoteNumber: "",
  proformaNumber: "",
  patientDto: "",
  observations: "",
};

export const newSaleLine = {
  id: -1,
  code: "",
  description: "",
  pvpOr: 0,
  pvp: 0,
  dto: 0,
  ivaOr: 0,
  iva: 0,
  pvu: 0,
  uds: 1,
  total: 0,
  stock: "",
  dtoMax: "",
  pvpOffer: "",
  offerFrom: "",
  offerTo: "",
  pvpSpecial: "",
  specialUds: 2,
  checkStock: false,
  healthControl: null,
  provider: "",
  providerId: "",
  commision: "",
  ivaBought: 0,
  cardId: -1,
  cardType: "",
  lastPurchaseBruto: "",
  lastPurchaseNeto: "",
  exencionCodigo: "",
  exencionDescripcion: "",
};

export const newCrossSelling = {
  nOperation: "",
  sale: {
    date: "",
    agent: "",
    patient: "",
    lines: [],
    total: "",
    delivered: "",
    remaining: "",
  },
  type: "",
  agent: -1,
};

export const newOrder = {
  id: -1,
  idPaciente: -1,
  codPaciente: "",
  nOperation: "",
  name: "",
  lastName: "",
  address: "",
  city: "",
  province: "",
  postalCode: "",
  nif: "",
  nifType: "00",
  date: "",
  phone: "",
  status: "Encargo",
  performedBy: -1,
  campaign: -1,
  lines: [
    {
      id: -1,
      code: "",
      description: "",
      pvpOr: 0,
      pvp: 0,
      dto: 0,
      ivaOr: 0,
      iva: 0,
      pvu: 0,
      uds: 1,
      total: 0,
      stock: "",
      dtoMax: "",
      pvpOffer: "",
      offerFrom: "",
      offerTo: "",
      pvpSpecial: "",
      specialUds: 2,
      checkStock: false,
      healthControl: null,
      provider: "",
      providerId: "",
      commision: "",
      ivaBought: 0,
      cardId: -1,
      cardType: "",
      lastPurchaseBruto: "",
      lastPurchaseNeto: "",
    },
  ],
  totalDto: 0,
  totalBase: 0,
  totalIVA: 0,
  total: 0,
  ivas: [
    {
      percIVA: 21,
      base: 0,
      iva: 0,
      total: 0,
    },
  ],
  carts: [],
  patientDto: "",
  observations: "",
};

export const newQuote = {
  id: -1,
  idPaciente: -1,
  codPaciente: "",
  nOperation: "",
  name: "",
  lastName: "",
  address: "",
  city: "",
  province: "",
  postalCode: "",
  nif: "",
  nifType: "00",
  date: "",
  phone: "",
  status: "Presupuesto",
  performedBy: -1,
  campaign: -1,
  lines: [
    {
      id: -1,
      code: "",
      description: "",
      pvpOr: 0,
      pvp: 0,
      dto: 0,
      ivaOr: 0,
      iva: 0,
      pvu: 0,
      uds: 1,
      total: 0,
      stock: "",
      dtoMax: "",
      pvpOffer: "",
      offerFrom: "",
      offerTo: "",
      pvpSpecial: "",
      specialUds: 2,
      checkStock: false,
      healthControl: null,
      provider: "",
      providerId: "",
      commision: "",
      ivaBought: 0,
      cardId: -1,
      cardType: "",
      lastPurchaseBruto: "",
      lastPurchaseNeto: "",
    },
  ],
  totalDto: 0,
  totalBase: 0,
  totalIVA: 0,
  total: 0,
  ivas: [
    {
      percIVA: 21,
      base: 0,
      iva: 0,
      total: 0,
    },
  ],
  carts: [],
  accepted: "",
  expirationDate: "",
  patientDto: "",
  observations: "",
};
